import { checkAccess } from 'app/actions/app.actions';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { isChainHeadSelector, isSuperChainSelector } from 'selectors';
import * as api from 'dashboard/resources/earnings.api';
import template from './earnings-widget.html';

const EARNINGS_HISTORY_PERMISSION = 'earnings.history';

const mapStateToThis = ({ session, dictionary }) => {
  const { locale, retailer } = session;
  const isSuperChain = isSuperChainSelector({ session });
  const isChainHead = isChainHeadSelector({ session });
  const terms = dictionary.terms[locale];

  return {
    retailer,
    isSuperChain,
    isChainHead,
    terms,
  };
};

const mapDispatchToThis = {
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', 'gettextCatalog', '$state')
class EarningsWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.activeTabIdx = 0;
    this.isHistoryLinkVisible = (!this.isSuperChain || this.isChainHead) && this.checkAccess(EARNINGS_HISTORY_PERMISSION);
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(() => api.fetchEarnings(retailerId), this.transformData.bind(this));
  }

  $onDestroy() {
    this.unsubscribe();
  }

  transformData(data) {
    const findDataItem = (dataItems, periodType) => dataItems.find((item) => item.periodType === periodType);
    const generateTab = (dataItem, periodType, title) => ({
      title,
      tabTitle: periodType,
      total: dataItem ? dataItem.earningsTotal : 0,
      delta: dataItem ? dataItem.earningsDelta : 0,
      deltaAsPerc: dataItem ? dataItem.deltaAsPerc : false,
    });

    return [
      generateTab(findDataItem(data, 'WTD'), 'WTD', this.gettextCatalog.getString('Week to Date Total Earnings')),
      generateTab(findDataItem(data, 'MTD'), 'MTD', this.gettextCatalog.getString('Month to Date Total Earnings')),
      generateTab(findDataItem(data, 'QTD'), 'QTD', this.gettextCatalog.getString('Quarter to Date Total Earnings')),
      generateTab(findDataItem(data, 'YTD'), 'YTD', this.gettextCatalog.getString('Year to Date Total Earnings')),
    ];
  }
}

export default class EarningsWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = EarningsWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/earnings/earnings-widget-component.js